import React, { } from 'react'
import Wrapper from '../../helpers/Wrapper'
import LinkButton from '../../ui/LinkButton';
import { apiClient } from '../../helpers/Axios';
import { displayImage } from '../../helpers/config';
import CountdownTimer from '../CountdownTimer';
import { useQuery } from '@tanstack/react-query';

function SpecialOffer() {

    const { data, isPending: loading } = useQuery({
        queryKey: ['specialproduct'],
        queryFn: async () => {
            const res = await apiClient.get('/offer/special')
            return res?.data
        }
    })


    if (loading) {
        return (
            <>Loading...</>
        )
    }

    return (
        <div>
            {data ? (
                <div className='w-full relative overflow-hidden h-full'>
                    {/* Image */}
                    <div className="relative w-full overflow-hidden pt-[100%]  md:pt-[45%]">
                        <img
                            src={displayImage(data?.image)} alt=""
                            className="absolute top-0 left-0 bottom-0 right-0 w-full h-full object-cover"
                        />
                    </div>

                    {/* Content */}
                    <div className="absolute top-0 items-center h-full flex w-full">
                        <Wrapper>
                            <div className='space-y-2 md:pl-24'>
                                <h4 className='text-[clamp(1.2rem,2vw+1rem,1.29rem)] text-gray-500'>Special Offer</h4>
                                <h1 className='text-[clamp(2rem,2vw+1rem,3rem)] text-secondary lg:max-w-5xl'>{data?.title}</h1>
                                <p className='text-[clamp(0.9rem,2vw+1rem,1.1rem)]'>{data?.description}</p>
                                <CountdownTimer targetDate={data?.product?.dealEnd} />
                                <div className="pt-6">
                                    <LinkButton to={`/product/${data?.product?.slug}`} black>Explore More</LinkButton>
                                </div>
                            </div>
                        </Wrapper>
                    </div>
                </div>
            ) : null}
        </div>
    )
}

export default SpecialOffer